import { render, staticRenderFns } from "./zlPlace.vue?vue&type=template&id=31b43b7a&scoped=true"
import script from "./zlPlace.vue?vue&type=script&lang=js"
export * from "./zlPlace.vue?vue&type=script&lang=js"
import style0 from "./zlPlace.vue?vue&type=style&index=0&id=31b43b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b43b7a",
  null
  
)

export default component.exports